module.exports = __webpack_public_path__ + "static/img/back1.1342273.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/back1.jpg
// module id = eJ1l
// module chunks = 128